<template>
  <div class="home">
    <div class="home_top">
      <img :src="topAdvert.imageUrl" alt="" style="height:100%" 
           @click="intoAdvert(topAdvert)"/>
      <webHeader textColor="#fff"></webHeader>
      <webMenu></webMenu>
    </div>
    
    <div class="main-container">
      <div class="module main-width">
        <el-row :gutter="30">
          <el-col :span="16">
            <el-carousel height="518px">
              <el-carousel-item v-for="item in banners" :key="item.id" style="text-align: center">
                <img :src="item.imageUrl" alt="" style="width: 100%;height:100%" 
                      @click="intoAdvert(item)"/>
              </el-carousel-item>
            </el-carousel>
          </el-col>
          <el-col :span="8">
            <el-tabs v-model="activeName" style="height: 414px">
              <el-tab-pane :label="$t('moduleTitle.news')" name="new">
                <div v-if="!news.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
                <div v-for="(item, i) in news" :key="i" class="new_active flex-width">
                  <div class="title link" @click="detailInfo(item)">{{item.title}}</div>
                  <div class="date">{{item.createTime | formatShowDate}}</div>
                </div>
              </el-tab-pane>
              <el-tab-pane :label="$t('moduleTitle.activity')" name="active">
                <div v-if="!activetis.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
                <div v-for="(item, i) in activetis" :key="i" class="new_active flex-width">
                  <div class="title link" @click="detailInfo(item)">{{item.title}}</div>
                  <div class="date">{{item.createTime | formatShowDate}}</div>
                </div>
              </el-tab-pane>
            </el-tabs>

            <div class="notice flex-width">
              <div class="name">{{$t('moduleTitle.notice')}}</div>
              <div class="content">
                <div class="title link" v-for="(item, i) in notice" :key="i" @click="detailInfo(item)">{{item.title}}</div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="top_space_20">
          <el-col :span="14">
            <div class="icon_menu flex-width">
              <div v-for="(item, i) in iconMenu" :key="i" class="icon_item">
                <i class="iconfont icon-shezhi" :class="['icon-' + item.icon]"></i>
                <p>{{item.title}}</p>
              </div>
            </div>
          </el-col>
          <el-col :span="10">
            <el-row :gutter="10" class="ad_img">
              <el-col :span="12" v-for="advert in middleAdvert.slice(0, 2)" :key="advert.id">
                <img :src="advert.imageUrl" alt="" @click="intoAdvert(advert)">
              </el-col>
            </el-row>
          </el-col>
        </el-row>

        <el-row :gutter="30" class="top_space_30">
          <el-col :span="16">
            <el-tabs v-model="sigleTab">
              <el-tab-pane :label="$t('moduleTitle.project')" name="first">
                <div v-if="!projects.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
                <el-row :gutter="30">
                  <el-col :span="12" v-for="(item, i) in projects" :key="i">
                    <div class="project_item">{{item.name}}</div>
                  </el-col>
                </el-row>
              </el-tab-pane>
            </el-tabs>

            <div class="input_tab">
              <div class="tab_input">
                <el-input :placeholder="$t('common.searchPlaceholder')" 
                          v-model="reportTitle" 
                          size="small" style="width: 300px" clearable>
                  <template slot="append"><span @click="getReport()">{{$t('common.search')}}</span></template>
                </el-input>
              </div>
              <el-tabs v-model="sigleTab" class="top_space_20">
                <el-tab-pane :label="$t('moduleTitle.report')" name="first">
                  <div v-if="!reports.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
                  <el-row :gutter="30">
                    <el-col :span="12" v-for="(item, i) in reports" :key="i" class="flex-width report_item">
                      <div class="title link" @click="downLoadItem(item)">{{item.title}}</div>
                      <div class="date">{{item.createTime | formatShowDate}}</div>
                    </el-col>
                  </el-row>
                </el-tab-pane>
              </el-tabs>
            </div>
          </el-col>

          <el-col :span="8">
            <el-tabs v-model="sigleTab">
              <el-tab-pane :label="$t('moduleTitle.member')" name="first">
                <div v-if="!allianceMember.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
                <div v-for="(item, i) in allianceMember" :key="i" class="member_item flex-width">
                  <div class="title link">{{item.name}}</div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </el-col>
        </el-row>
      </div>

      <div class="black_bg">
        <div class="module main-width">
          <el-tabs v-model="sigleTab">
            <el-tab-pane :label="$t('moduleTitle.partner')" name="first">
              <div v-if="!partners.length" class="no-data"><i class="iconfont icon-zanwushuju"></i>{{$t('common.noData')}}</div>
              <el-row :gutter="30">
                <el-col :span="6" v-for="(item, i) in partners" :key="i">
                  <div class="logo_img">
                    <img :src="item.logoUrl" alt="">
                  </div>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>

          <el-tabs v-model="sigleTab" class="top_space_20">
            <el-tab-pane :label="$t('moduleTitle.link')" name="first">
              <el-row :gutter="30">
                <el-col :span="8">
                  <el-dropdown style="width: 80%" trigger="click" @command="command">
                    <span class="el-dropdown-link">
                      国际工商会组织联盟盟友<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in links.filter(link => link.type === 'international')"
                                        :key="item.id"
                                        :command="item.url">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
                <el-col :span="8">
                  <el-dropdown style="width: 80%" @command="command">
                    <span class="el-dropdown-link">
                      国家级工商会联盟盟友<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in links.filter(link => link.type === 'country')"
                                        :key="item.id"
                                        :command="item.url">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
                <el-col :span="8">
                  <el-dropdown style="width: 80%" @command="command">
                    <span class="el-dropdown-link">
                      集团品牌商会联盟盟友<i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in links.filter(link => link.type === 'group')"
                                        :key="item.id"
                                        :command="item.url">{{item.name}}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </el-col>
              </el-row>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
      

    </div>
  </div>
</template>

<script>
import webHeader from './layout/header'
import webMenu from './layout/menu'

export default {
  name: 'home',
  components: { 
    webHeader,
    webMenu
  },
  data () {
    return {
      input2: '',
      partners: [],
      projects: [
        {name: '优化营商合作环境'},
        {name: '陆海新通道关于稳岗扩就业'},
        {name: '工商会联盟秘书处合作项目'},
        {name: '优化营商合作环境'},
        {name: '陆海新通道关于稳岗扩就业'},
        {name: '工商会联盟秘书处合作项目'},
      ],
      sigleTab: 'first',
      iconMenu: [
        {icon: 'shangwumaoyi', title: '促进和服务贸易工作'},
        {icon: '121', title: '促进和服务企业跨境投资'},
        {icon: 'icon_chanyelian', title: '促进产业链开放合作'},
        {icon: 'a-falv2', title: '深化商事法律服务合作'},
        {icon: 'gengduo', title: '查看更多'},
      ],
      activeName: 'new',
      banners: [],
      topAdvert: {},
      stat: {
        items: []
      },
      opinions: [],
      allianceMember: [],
      notice: [],
      reports: [],
      activetis: [],
      news: [],
      middleAdvert: [],
      navId: null,
      reportTitle: '',
      links: [],
    }
  },
  filters: {
  },
  computed: {
    menuList: {
      get () {
        return this.$store.state.common.menuList
      },
      set (val) {
        this.$store.commit('common/updateMenuList', val)
      }
    },
    localeLang: {
      get () { return this.$store.state.common.localeLang },
    }
  },
  watch: {
    menuList: {
      handler (val) {
        if (val && val.length) {
          this.navId = this.$findMenuOfUrl(val, this.$route.path)
          this.getAdvertOfNavId()
        }
      },
      immediate: true
    },
    localeLang (val) {
      this.review()
      this.getAdvertOfNavId()
    }
  },
  mounted () {
    this.review()
  },
  methods: {
    downLoadItem (item) {
      if (item.filePath) {
        let eleLink = document.createElement('a')   // 创建隐藏的可下载链接
        eleLink.download = item.title
        eleLink.style.display = 'none'
        eleLink.href = item.filePath
        document.body.appendChild(eleLink)
        eleLink.click()                                // 触发点击
        document.body.removeChild(eleLink)     
      }
    },
    review () {
      this.getContent()
      this.getProject()
      this.getAllianceMember()
      this.getReport()
      this.getLinks()
      this.getPartner()
    },
    getLinks () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/links/list'),
        method: 'post',
        data: {
          isPage: false,
          data: {
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.links = res.data.result.list || []
        }
      })
    },
    command (val) {
      window.open(val)
    },
    getPartner () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/partner/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 10,
          data: {
            lang: this.localeLang
          },
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.partners = res.data.result.list || []
        }
      })
    },
    getReport () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/researchReport/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 10,
          data: {
            lang: this.localeLang
          },
          params: {
            title$LIKE: this.reportTitle
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.reports = res.data.result.list || []
        }
      })
    },
    getAllianceMember () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/allianceMember/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 10,
          data: {
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.allianceMember = res.data.result.list || []
        }
      })
    },
    getProject () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/project/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 6,
          data: {
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.projects = res.data.result.list || []
        }
      })
    },
    getAdvertOfNavId () {
      if (!this.navId) return 
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/bannerConfig/list'),
        method: 'post',
        data: {
          isPage: false,
          data: {
            navId: this.navId,
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          let array = res.data.result.list || []
          this.banners = array.filter(item => item.position === 1) // 首页轮播
          this.topAdvert = array.find(item => item.position === 3) || {}
          this.middleAdvert = array.filter(item => item.position === 5) // 中部内容
        }
      })
    },
    getContent () {
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/contentManagement/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 5,
          data: {
            contentType: 1, // 新闻动态
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.news = res.data.result.list || []
        }
      })
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/contentManagement/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 5,
          data: {
            contentType: 2, // 重要活动
            lang: this.localeLang
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.activetis = res.data.result.list || []
        }
      })
      this.$http({
        url: this.$http.adornUrl(window.SITE_CONFIG.basContextPath + '/contentManagement/list'),
        method: 'post',
        data: {
          pageNum: 1,
          pageSize: 2,
          data: {
            lang: this.localeLang,
            contentType: 3 // 联盟公告
          }
        }
      }).then(res => {
        if (res.data && res.data.code === 'C0000') {
          this.notice = res.data.result.list || []
        }
      })
    },
    detailInfo (item) {
      const routeUrl = this.$router.resolve({
        path: '/info',
        query: {id: item.id}
      })
      window.open(routeUrl.href, '_blank')
    },
    intoAdvert (ad) {
      let url = ad.linkUrl
      if (!url) return 
      if (!url.startsWith('http://') && !url.startsWith('https://')) {
        url = 'http://' + url
      }
      window.open(url, ad.linkTarget === 1 ? '_self' : '_blank')
    },
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/public.scss";
.home{
  .black_bg{
    background: #f5f5f5;
  }
  .input_tab{
    position: relative;
  }
  .tab_input{
    position: absolute;
    top: 0;
    right: 0;
    z-index: 10;
  }
  .el-dropdown-link{
    border: 1px solid #d5d5d5;
    display: inline-block;
    border-radius: 4px;
    padding: 10px 20px;
    text-align: center;
    width: 100%;
  }
  .home_top{
    width: 100%;
    height: 280px;
    max-width: 1920px;
    margin: auto;
    position: relative;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .logo_img{
    width: 100%;
    height: 80px;
    img{
      width: 100%;
      height: 100%;
    }
  }
  .member_item{
    padding: 12px 10px;
    .title:before{
      content: '';
      display: inline-block;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: #b2d0e0;
      margin-right: 10px;
      vertical-align: 0.15em;
    }
  }
  .member_item:nth-child(2n){
    background: #f6f7fc;
  }
  .report_item{
    font-size: 16px;
    line-height: 30px;
    padding: 3px 0;
    border-right: 1px solid #ddd;
    .title:before{
      content: '·';
      margin-right: 10px;
    }
  }
  .project_item{
    background: #f4f9ff;
    width: 100%;
    height: 50px;
    line-height: 50px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    margin-bottom: 12px;
    text-align: center;
  }
  .notice{
    background: #f6f6f6;
    padding: 18px;
    margin-top: 20px;
    .name{
      width: 52px;
      font-size: 18px;
      color: #3a6cb1;
      border-right: 1px solid #999;
      padding-right: 18px;
    }
    .content{
      flex: 1;
      padding-left: 18px;
    }
    .title{
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: normal;
      line-height: 24px;
    }
  }
  .icon_menu{
    background: #f6f6f6;
    padding: 20px;
    box-sizing: border-box;
    i{
      font-size: 38px;
      color: #4474b6;
      display: inline-block;
      margin-bottom: 10px;
    }
    .icon_item{
      border: 1px solid #e6e6e6;
      border-radius: 10px 0 10px 0;
      padding: 20px 10px;
      text-align: center;
      width: 18%;
      height: 130px;
      box-sizing: border-box;
      cursor: pointer;
    }
  }
  .ad_img{
    img{
      width: 100%;
      height: 170px;
    }
  }
}
.main-container {
  margin: auto;
  max-width: 1920px;
  padding: 20px 0;
  .module{
    padding: 20px;
  }
  .main-width{
    max-width: $main_content_width;
    margin: auto;
  }
}
</style>
<style lang="scss">
.home{
  .el-input-group__append{
    cursor: pointer;
    background: #409EFF;
    color: #fff;
    span{
      display: inline-block;
      width: 100%;
      height: 100%;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/home.vue